if (jQuery('#identification').length > 0) {
  jQuery(function ($) {
    toggleDisableButton();
    toggleErrors();
    
    $('#identification').keyup(function (event) {
      var idLength = $(this).val().length;
      if (idLength === 10 || idLength === 11 || idLength === 13 || idLength === 0) {
        $(this).removeClass('error');
        $('#wrong-id').removeClass('showed');
        $('#wrong-id').html('');
        toggleDisableButton();
        return true;
      } else {
        $(this).addClass('error');
        return false;
      }
    });

    $('#identification').focusout(function () {
      toggleErrorMessage();
      toggleDisableButton();
    });

    $('#terms').change(function () {
      toggleErrors();
      toggleDisableButton();
    });
  });
}

function toggleDisableButton() {
  if($('#wrong-id').html() == '' && $('#terms').is(':checked')) {
    $('[name="checkout"]').removeAttr( 'disabled' );  
  } else {
    $('[name="checkout"]').attr( 'disabled', true );
  }
}

function toggleErrors() {
  //Terms and conditions
  if ($('#terms').is(':checked')) {
    $('#terms-error').html('');
  } else {
    $('#terms-error').html(theme.strings.cartTermsNotChecked);
  }
  if($('#identification').val() == '') {
    $('#wrong-id').addClass('showed');
    $('#wrong-id').html('Este campo es obligatorio');
  }
}

function toggleErrorMessage() {
  var identification = '';
  if ($('#identification').length > 0) {
    identification = $('#identification').val();
  }

  var validIdObj = validateId(identification);
  var validId = validIdObj.isValid;
  var textInvalidId = $('#wrong-id');
  
  if (validId === false) {    
    textInvalidId.html(validIdObj.message);
    textInvalidId.addClass('showed');
    $('#identification').addClass('error');
  } else {
    textInvalidId.html('');
    textInvalidId.removeClass('showed');
    $('#identification').removeClass('error');
  }  
}

function validateId(identification) {

  var returnObj = {isValid: true, message: ''};
  var d1, d2, d3, d4, d5, d6, d7, d8, d9, d10;
  var p1, p2, p3, p4, p5, p6, p7, p8, p9;

  if (identification != '') {
    var res = identification.match(/-/g);
    if (res == '-') {
      identification = identification.replace('-', '');
    }

    var numId = identification;
    if (numId.length != 7) {
      var sum = 0;
      var residue = 0;
      var pri = false;
      var pub = false;
      var nat = false;
      var numProvinces = 30;
      var modulo = 11;

      // Verify that the field does not contain letters
      var ok = 1;
      for (i = 0; i < numId.length && ok == 1; i++) {
        var n = parseInt(numId.charAt(i));
        if (isNaN(n)) ok = 0;
      }
      if (ok == 0) {
        returnObj = {isValid: false, message: 'No puede ingresar caracteres en el campo de Cédula/RUC.'};
      }

      if (numId.length < 10) {
        returnObj = {isValid: false, message: 'Número de dígitos incorrecto.'};
      }

      // The first two digits correspond to the province code
      var province = numId.substr(0, 2);
      if (province < 1 || province > numProvinces || (province > 24 && province < 30)) {
        returnObj = {isValid: false, message: 'El código de provincia (dos primeros dígitos) es inválido.'};
      }

      // Storing the ID digits in variables
      d1 = numId.substr(0, 1);
      d2 = numId.substr(1, 1);
      d3 = numId.substr(2, 1);
      d4 = numId.substr(3, 1);
      d5 = numId.substr(4, 1);
      d6 = numId.substr(5, 1);
      d7 = numId.substr(6, 1);
      d8 = numId.substr(7, 1);
      d9 = numId.substr(8, 1);
      d10 = numId.substr(9, 1);

      // Check the third digit
      if (d3 == 7 || d3 == 8) {
        returnObj = {isValid: false, message: 'El tercer dígito ingresado es inválido.'};
      }

      if (numId.length == 13 && d3 != 9 && d3 != 6) {
        numId = numId.substr(1, 10);
      }
      // For natural people (module 10)
      if (numId.length == 10 && d3 != 9) {
        nat = true;
        p1 = d1 * 2;
        if (p1 >= 10) p1 -= 9;
        p2 = d2 * 1;
        if (p2 >= 10) p2 -= 9;
        p3 = d3 * 2;
        if (p3 >= 10) p3 -= 9;
        p4 = d4 * 1;
        if (p4 >= 10) p4 -= 9;
        p5 = d5 * 2;
        if (p5 >= 10) p5 -= 9;
        p6 = d6 * 1;
        if (p6 >= 10) p6 -= 9;
        p7 = d7 * 2;
        if (p7 >= 10) p7 -= 9;
        p8 = d8 * 1;
        if (p8 >= 10) p8 -= 9;
        p9 = d9 * 2;
        if (p9 >= 10) p9 -= 9;
        modulo = 10;
      }
      // Only for public companies (module 11)
      else if (d3 == 6) {
        pub = true;
        p1 = d1 * 3;
        p2 = d2 * 2;
        p3 = d3 * 7;
        p4 = d4 * 6;
        p5 = d5 * 5;
        p6 = d6 * 4;
        p7 = d7 * 3;
        p8 = d8 * 2;
        p9 = 0;
      }
      // Only for private entities (module 11)
      else if (d3 == 9) {
        pri = true;
        p1 = d1 * 4;
        p2 = d2 * 3;
        p3 = d3 * 2;
        p4 = d4 * 7;
        p5 = d5 * 6;
        p6 = d6 * 5;
        p7 = d7 * 4;
        p8 = d8 * 3;
        p9 = d9 * 2;
      }

      sum = p1 + p2 + p3 + p4 + p5 + p6 + p7 + p8 + p9;
      residue = sum % modulo;
      var checkDigit = residue == 0 ? 0 : modulo - residue;

      if (pub == true) {
        if (checkDigit != d9) {
          returnObj = {isValid: false, message: 'El RUC ingresado (empresa sector público) es incorrecto.'};
        }
        if (numId.substr(9, 4) != '0001') {
          returnObj = {isValid: false, message: 'El RUC ingresado (empresa sector público) debe terminar con 0001.'};
        }
      } else if (pri == true) {
        if (checkDigit != d10) {
          returnObj = {isValid: false, message: 'El RUC ingresado (empresa sector privado) es incorrecto.'};
        }
        if (numId.substr(10, 3) != '001') {
          returnObj = {isValid: false, message: 'El RUC ingresado (empresa sector privado) debe terminar con 001.'};
        }
      } else if (nat == true) {
        if (checkDigit != d10) {
          returnObj = {isValid: false, message: 'El número de cédula es incorrecto.'};
        }
        if (numId.length > 10 && numId.substr(10, 3) != '001') {
          returnObj = {isValid: false, message: 'El RUC ingresado es incorrecto.'};
        }
      } else if (nat == false && numId.length <= 13 && numId.length >= 10) {
        returnObj = {isValid: false, message: 'El RUC ingresado es incorrecto.'};
      }
    }
  } else {
    returnObj = {isValid: false, message: 'Este campo es obligatorio.'};
  }
  return returnObj;
}